export default "__VITE_ASSET__a8be8e71__$_?nuxt_component=async__"